"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { PremiumUpgradeConfirmDialog } from "@/components/layouts/premium-upgrade/premium-upgrade-confirm-dialog";
import type { usePremiumUpgradeRequest } from "@/components/layouts/premium-upgrade/use-premium-upgrade-request";
type PremiumUpgradeDialogHostProps = {
  confirmUpgrade: () => void;
  dialogOpen: boolean;
  dialogPhase: ReturnType<typeof usePremiumUpgradeRequest>["dialogPhase"];
  handleDialogOpenChange: (open: boolean) => void;
  isSubmitting: boolean;
};
export function PremiumUpgradeDialogHost(t0) {
  const $ = _c(6);
  const {
    confirmUpgrade,
    dialogOpen,
    dialogPhase,
    handleDialogOpenChange,
    isSubmitting
  } = t0;
  let t1;
  if ($[0] !== confirmUpgrade || $[1] !== dialogOpen || $[2] !== dialogPhase || $[3] !== handleDialogOpenChange || $[4] !== isSubmitting) {
    t1 = <PremiumUpgradeConfirmDialog isSubmitting={isSubmitting} onConfirm={confirmUpgrade} onOpenChange={handleDialogOpenChange} open={dialogOpen} phase={dialogPhase} />;
    $[0] = confirmUpgrade;
    $[1] = dialogOpen;
    $[2] = dialogPhase;
    $[3] = handleDialogOpenChange;
    $[4] = isSubmitting;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}